import React, {
  createContext, useContext, useState, useEffect, useRef
} from 'react';
import PropTypes from 'prop-types';
import { useConfigService } from '@thd-nucleus/experience-context';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { getCustomerRecentActivity } from './api/accountActivityLogApi';
import { flags } from './constants';

export function ActivityLogProvider({ children }) {

  const activityLogEnabled = useConfigService(flags.ENABLE_ACCOUNT_ACTIVITY_LOG);
  const { isLoggedIn, session } = useThdCustomer();

  const [loading, setLoading] = useState(true);
  const [activities, setActivities] = useState([]);
  const userSessionId = session?.split(':')[1];

  async function refreshData() {

    if (isLoggedIn) {
      const data = await getCustomerRecentActivity();
      if (data && data?.length > 0) {
        setActivities(data);
        setLoading(false);
      }
    }
  }

  useEffect(() => {
    if (activityLogEnabled) {
      refreshData();
    }
  }, []);

  const value = {
    activities,
    userSessionId,
    loading,
    refreshData,
    updateActivity: setActivities
  };

  return (
    <ActivityLogContext.Provider value={value}>
      {children}
    </ActivityLogContext.Provider>
  );
}

export const ActivityLogContext = createContext({});

export function useActivityLogContext() {
  return useContext(ActivityLogContext);
}

ActivityLogProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
